// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-invitation-inscription-actions-modal .modal2__container {
    max-width: 400px;
}

.tournament-invitation-inscription-actions-modal .modal2__header {
    border-bottom: none;
}

.tournament-invitation-inscription-actions-modal__container {
    margin: 0 var( --space );
}

.tournament-invitation-inscription-actions-modal .baloa-hyperlink {
    color: var( --primary-very-dark-color );
    font-weight: var( --font-medium );
}

.tournament-invitation-inscription-actions-modal .baloa-table {
    color: var( --primary-dark-color );
    margin: var( --space-and-half ) 0;
}

.tournament-invitation-inscription-actions-modal__action-btns {
    display: flex;
    justify-content: flex-end;
    border-top: 2px solid var( --new-input-background-color );
    padding: var( --space-half ) var( --space );
}

.tournament-invitation-inscription-actions-modal__action-btns .button {
    display: flex;
    justify-content: flex-end;
    border-top: 2px solid var( --new-input-background-color );
}

.tournament-invitation-inscription-actions-modal__action-btns .button:first-of-type {
    margin-right: var( --space-half-quarter );
    color: var( --basic-gray-color );
    border: 2px solid var( --basic-gray-color );
}

.tournament-invitation-inscription-actions-modal__action-btns .button:first-of-type:hover {
    background: none;
}

.tournament-invitation-inscription-actions-modal__action-btns .button:last-of-type {
    background-color: var( --error-color );    
}

.tournament-invitation-inscription-actions-modal__action-btns .button {
    padding: var( --space-half ) var( --space );
}

.tournament-invitation-inscription-actions-modal__action-btns .accept_inscription.button:last-of-type {
    background-color: var(--new-green-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-invitation-inscription-actions-modal/TournamentInvitationInscriptionActionsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uCAAuC;IACvC,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yDAAyD;IACzD,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yDAAyD;AAC7D;;AAEA;IACI,yCAAyC;IACzC,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wCAAwC;AAC5C","sourcesContent":[".tournament-invitation-inscription-actions-modal .modal2__container {\n    max-width: 400px;\n}\n\n.tournament-invitation-inscription-actions-modal .modal2__header {\n    border-bottom: none;\n}\n\n.tournament-invitation-inscription-actions-modal__container {\n    margin: 0 var( --space );\n}\n\n.tournament-invitation-inscription-actions-modal .baloa-hyperlink {\n    color: var( --primary-very-dark-color );\n    font-weight: var( --font-medium );\n}\n\n.tournament-invitation-inscription-actions-modal .baloa-table {\n    color: var( --primary-dark-color );\n    margin: var( --space-and-half ) 0;\n}\n\n.tournament-invitation-inscription-actions-modal__action-btns {\n    display: flex;\n    justify-content: flex-end;\n    border-top: 2px solid var( --new-input-background-color );\n    padding: var( --space-half ) var( --space );\n}\n\n.tournament-invitation-inscription-actions-modal__action-btns .button {\n    display: flex;\n    justify-content: flex-end;\n    border-top: 2px solid var( --new-input-background-color );\n}\n\n.tournament-invitation-inscription-actions-modal__action-btns .button:first-of-type {\n    margin-right: var( --space-half-quarter );\n    color: var( --basic-gray-color );\n    border: 2px solid var( --basic-gray-color );\n}\n\n.tournament-invitation-inscription-actions-modal__action-btns .button:first-of-type:hover {\n    background: none;\n}\n\n.tournament-invitation-inscription-actions-modal__action-btns .button:last-of-type {\n    background-color: var( --error-color );    \n}\n\n.tournament-invitation-inscription-actions-modal__action-btns .button {\n    padding: var( --space-half ) var( --space );\n}\n\n.tournament-invitation-inscription-actions-modal__action-btns .accept_inscription.button:last-of-type {\n    background-color: var(--new-green-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
